(function () {

    'use strict';

    angular.module('Services').service('AccountingInvoiceShipmentsTableService', AccountingInvoiceShipmentsTableService);

    AccountingInvoiceShipmentsTableService.$inject = [
        'toastr',
        'TableLiteFactory',
        '$location',
        'AccountingService',
        '$filter',
        'Units',
        'ConfirmationModalFactory'
    ];

    function AccountingInvoiceShipmentsTableService(
        toastr,
        TableLiteFactory,
        $location,
        AccountingService,
        $filter,
        Units,
        ConfirmationModalFactory
    ) {
        return function (invoiceId, invoiceData, shipments, refreshTableData, reconciled) {
            
            const reconcileConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.reconcileShipment.MESSAGE',
                code: 'messages.warning.reconcileShipment.CODE'
            });

            const actionHeader = {
                label: 'Actions',
                viewName: 'action',
                class: 'text-center',
                filter: {
                    type: 'button'
                }
            };
            const selected = [];

            const optionButton = {
                class: 'btn-primary',
                label: 'Approve Selected ',
                tooltip: 'Approve Selected',
                onClick: function () {
                    const selectedData = tableData.data.filter((value) => {if(value.isSelected) return value;});
                    const shipmentIds = [];
                    if(!selectedData.length){
                        toastr.error('No Shipment to reconcile.');
                        return;
                    }
                    for (let i in selectedData){
                        shipmentIds.push(selectedData[i].id);
                    }
                    // add APi call 
                    reconcileConfirmation.getInstance().result.then(cond => {
                        if (cond) {
                            reconcileSelectedShipment(selectedData[0].invoiceId,shipmentIds);
                        }
                    });
                }
            }

            const approvedAll ={
                class: 'btn-success',
                label: 'Approve All ',
                tooltip: 'Approve All',
                onClick: function () {
                    const selectedData = tableData.data;
                    if(!selectedData.length){
                        toastr.error('No Shipment to reconcile.');
                        return;
                    }
                    // add APi call 
                    reconcileConfirmation.getInstance().result.then(cond => {
                        if (cond) {
                            AccountingService.Invoices.approveAllUnreconciledShipments(invoiceId,res=>{
                                toastr.success('Successfully approved all shipments!')
                                tableActions.sendRequest({})
                            },
                            err=>{
                                toastr.error(err.message)
                            })
                        }
                    });
                }
            }

            const exportButton ={
                class: 'btn-primary',
                label: `Export All`, 
                tooltip: 'Export',
                onClick: function () {
                    const selectedData = tableData.data;
                    if(!selectedData.length){
                        toastr.error('No Shipment to export.');
                        return;
                    }
                    AccountingService.Invoices.exportAllInvoice(invoiceId,res=>{
                        toastr.success('Successfully exported!');
                        tableActions.sendRequest({})
                    },
                    err=>{
                        toastr.error(err.message)
                    },reconciled)
                }
            }

            const selectHeader = {
                    label: 'SELECT',
                    class: 'text-center',
                    filter: {
                        type: 'checkbox'
                    }
            };

            const headerData = [
                {
                    label: 'Consignment No.',
                    viewName: 'consignmentNo'
                },
                {
                    label: 'Customer Name',
                    viewName: 'customerName'
                },
                {
                    label: 'Sell Price',
                    viewName: 'sellPrice'
                },
                {
                    label: 'Payment Type',
                    viewName: 'paymentType'
                },
                {
                    label: 'Freight charge',
                    viewName: 'freightCharge'
                },
                {
                    label: 'Fuel Charge',
                    viewName: 'fuelCharge'
                },
                {
                    label: 'Other Charges',
                    viewName: 'otherCharges'
                },
                {
                    label: 'Premium (Ex. Gst) ',
                    viewName: 'premiumExcGst'
                },
                 {
                    label: 'GST',
                    viewName: 'gst'
                },
                {
                    label: 'Surcharges',
                    viewName: 'surcharges'
                },
                {
                    label: 'Total Charge (Ex. Tax)',
                    viewName: 'totalChargeExTax'
                },
                {
                    label: 'Total Inc. Fuel And Fees (Ex. Tax)',
                    viewName: 'totalIncFuelAndFeesExTax'
                },
                {
                    label: 'Expected Margin $',
                    viewName: 'expectedMarginValue'
                },
                {
                    label: 'Actual Margins $',
                    viewName: 'actualMarginValue'
                },
                {
                    label: 'Actual Margins %',
                    viewName: 'actualMarginPercentage'
                }
            ]

            const headData = []
            const headerAction=[]
            if(!reconciled){
                headData.push(selectHeader);
                headerAction.push(optionButton,approvedAll,exportButton)
            }else{
                headerAction.push(exportButton)
            }

            for(let i in headerData){
                headData.push(headerData[i])
            }

            const tableData = {
                optionAddOns: {
                    buttons: headerAction
                },
                config: {
                    noPagination: false,
                    notTopOptions: false,
                    noHeaders: false,
                    noItemsView: false,
                    noFooter: false,
                    colMinWidth: '135px'
                },
                headers: headData,
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.Invoices.getReconciledShipment,
                callbackFormat: ['id','success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },postRequestErrorCallback: err => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc',
                    reconciled:reconciled
                },
                paramId: invoiceId
                
            });
            
            init();
            function init() {
                if (!reconciled) {
                    tableData.headers.push(actionHeader);
                }
            }

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                if (!data) { return null; }
                angular.forEach(data.content, function (shipment) {
                        let row = shipment;
                        row.sellPrice = $filter('bbaCurrency')(shipment.amount, shipment.currency);
                        row.consignmentNo = shipment.consignmentId;
                        row.customerName = angular.getObjVal(shipment, 'company.name') || 'N/A';
                        row.paymentType = paymentTypes(shipment.paymentType);
                        row.expectedMarginValue = $filter('bbaCurrency')(shipment.expectedMargin , shipment.currency);
                        // row.actualMarginValue = $filter('bbaCurrency')(shipment.shippingCost.valueMargin, shipment.currency);
                        row.actualMarginPercentValue = $filter('bbaCurrency')(shipment.shippingCost.percentValueMargin, shipment.currency);
                        
                        row.freightCharge = $filter('bbaCurrency')(shipment.invoiceDetails.freightCharge, shipment.currency);
                        row.fuelCharge = $filter('bbaCurrency')(shipment.invoiceDetails.fuelCharge, shipment.currency);
                        row.otherCharges = $filter('bbaCurrency')(shipment.invoiceDetails.otherCharges, shipment.currency);
                        row.totalChargeExTax = $filter('bbaCurrency')(shipment.invoiceDetails.totalChargeExcludingTax, shipment.currency);
                        row.totalIncFuelAndFeesExTax = $filter('bbaCurrency')(shipment.invoiceDetails.totalIncludingFuelAndFeesExcludingTax, shipment.currency);
                        // FI details
                        row.premiumExcGst = shipment.fiPolicyDetails ? $filter('bbaCurrency')((shipment.fiPolicyDetails.premium + shipment.fiPolicyDetails.platformFee), shipment.currency) :'N/A';
                        row.gst = shipment.fiPolicyDetails ? $filter('bbaCurrency')(shipment.fiPolicyDetails.gst, shipment.currency) :'N/A';

                        row.surcharges = shipment.shippingCost.surchargeTotal;


                        const ammountDiff = shipment.marginDifference;
                        const ammountDiffPercentage = Number(shipment.marginDifferencePercentage);
                        // if (ammountDiff < 0) {
                        //     row.amountDifference = `(${$filter('bbaCurrency')(ammountDiff * -1, shipment.currency)})`;
                        // } else {
                        //     row.amountDifference = $filter('bbaCurrency')(ammountDiff, shipment.currency);
                        // }
                        row.actualMarginPercentage = `${ammountDiffPercentage.toFixed(2)}`;
                        if(shipment.marginDifference < 0){
                            const marginDifference = $filter('bbaCurrency')(Math.abs(shipment.marginDifference), shipment.currency);
                            row.actualMarginValue = ` ( ${marginDifference} )`;
                        }else{
                            row.actualMarginValue = $filter('bbaCurrency')(ammountDiff, shipment.currency) ;
                        }

                        row.href = `/accounting/invoices/shipment-details/${shipment.id}`;
                        row.action = {
                            type: 'button',
                            buttons: [{
                                text: 'reconcile',
                                class: 'btn btn-primary btn-quirk btn-sm',
                                action: () => {
                                    approveForBilling(row);
                                }
                            }]
                        };

                        if(angular.getObjVal(row, 'invoiceDetails.hasDiscrepancy')) {
                            row.class = 'bg-warning' ;
                        }
                        tableData.data.push(row);
                    
                });
                 
                /*** END - Building of Data ***/
            }

            function paymentTypes(data){
                if(!data){return 'N/A'}
                let paymentType;
                if( data==='adhoc' || data==='sweep'){
                    paymentType = 'Credit Card - '+ data.charAt(0).toUpperCase() + data.slice(1) ;
                }else{
                    paymentType = 'On Account';
                }
                return paymentType;
            }

            function approveForBilling(shipment) {
                if(angular.getObjVal(shipment, 'invoiceDetails.hasDiscrepancy')) {
                    if (shipment.invoiceDetails.hasDiscrepancy) {
                        reconcileConfirmation.getInstance().result.then(cond => {
                            if (cond) {
                                callAPItoApproveBilling(shipment);
                            }
                        });
                    } else {
                        callAPItoApproveBilling(shipment);
                    }
                } else {
                    callAPItoApproveBilling(shipment);
                }
            }

            function reconcileSelectedShipment(invoiceId,shipmentIds){
                AccountingService.Invoices.unreconcileByShipmentForceApproved(success => {
                    toastr.success("Success", "Shipment successfully reconciled");
                    tableActions.sendRequest({});
                }, error => {
                    toastr.error("Error", error.message);
                }, invoiceId, shipmentIds);
            }

            function callAPItoApproveBilling(shipment){
                shipment.action.buttons[0].text = "Processing...";
                AccountingService.Invoices.reconcileByShipment(success => {
                    shipment.action.buttons[0].text = "Reconcile";
                    toastr.success("Success", "Shipment successfully reconciled");
                    tableActions.sendRequest({});
                }, error => {
                    shipment.action.buttons[0].text = "Reconcile";
                    toastr.error("Error", error.message);
                }, shipment.invoiceId, [shipment.id]);
            }

            function updateTableData() {
                tableActions.sendRequest({});
            }

            this.updateTableData = updateTableData;
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountingInvoiceShipmentsTableService.js